import { render, staticRenderFns } from "./Threshold.vue?vue&type=template&id=e3d065bc&scoped=true"
import script from "./Threshold.vue?vue&type=script&lang=js"
export * from "./Threshold.vue?vue&type=script&lang=js"
import style0 from "./Threshold.vue?vue&type=style&index=0&id=e3d065bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d065bc",
  null
  
)

export default component.exports